export const informationsSelector = state => state.information.list;

export const getInformationsFetchSelector = state => state.information.fetching.getInformations;
export const createInformationFetchSelector = state => state.information.fetching.createInformation;
export const updateInformationFetchSelector = state => state.information.fetching.updateInformation;
export const deleteInformationFetchSelector = state => state.information.fetching.deleteInformation;
